import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { Typography } from '@mui/material';
import { getServerTime } from '../redux/Actions';

const TimeClock = () => {
    const dispatch = useDispatch();

    const [currentTime, setCurrentTime] = useState('');

    useEffect(() => {
        let lastCheckTime = Date.now();
        const formatString = 'HH:mm:ss, dddd, D MMMM YYYY';
        const sessToken = sessionStorage.getItem("token");

        const updateClock = () => {
            const now = Date.now();

            if (!document.hidden) {
                if (Math.abs(now - lastCheckTime - 1000) > 20000) {
                    console.warn('⚠️ System time change detected!');
                    if (sessToken != null) {
                        dispatch(getServerTime(sessToken))
                    }
                }
            }

            lastCheckTime = now;

            const currentMoment = moment(
                typeof window.getTime === 'function' ? window.getTime() : new Date()
            ).format(formatString);

            setCurrentTime(currentMoment);
        };

        const interval = setInterval(updateClock, 1000);

        const handleVisibilityChange = () => {
            if (!document.hidden) {
                if (sessToken != null) {
                    dispatch(getServerTime(sessToken))
                }
                lastCheckTime = Date.now();
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            clearInterval(interval);
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);



    return (
        <>
            <Typography>{currentTime}</Typography>

        </>
    );
};

export default TimeClock;
